import { t } from 'i18next';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import Button from '../././Button';
import { useCurrentActor } from '../../hooks/useCurrentActor';
import SignInFormLink from '../Auth/SignInFormLink';
import Heading, { HeadingSize, HeadingVariant } from '../Heading';
import HeadingContext from '../Heading/HeadingContext';

import ErrorButtonWithFeedback from './ErrorButtonWithFeedback';
import { bodyForStatus, headerForStatus } from './errorMessages';
import { ErrorComponentProps, shouldShowSignIn } from './helpers';

const CardError = (props: ErrorComponentProps): JSX.Element => {
  const { caughtError, status } = props;
  const { actorType } = useCurrentActor();
  const errorLabel = headerForStatus(status);
  const errorBody = bodyForStatus(status);

  return (
    <HeadingContext>
      <Heading size={HeadingSize.LG} variant={HeadingVariant.Alert}>
        <FontAwesome name="exclamation-triangle" /> {errorLabel ?? caughtError?.name}
      </Heading>
      {errorBody ? <p>{errorBody}</p> : null}
      {caughtError && <p>{caughtError.message}</p>}
      {!__PRODUCTION__ && caughtError instanceof Error && <pre>{caughtError.stack}</pre>}
      {shouldShowSignIn(actorType, status) ? (
        <SignInFormLink Component={Button} />
      ) : (
        <ErrorButtonWithFeedback variant="text" {...props}>
          {t('errors.retry')}
        </ErrorButtonWithFeedback>
      )}
    </HeadingContext>
  );
};

export default CardError;
